export default __webpack_public_path__ + "static/main2-af303b536c614993b2ab452e3faacbe9.jpg";